import { Layout } from "./UI/Layout";

export function MainScreen() {
  return <Layout />;
}
